import * as React from 'react';

interface ImagePreviewProps {
    maxWidth: number;
    maxHeight: number;
    imageUrl: string;
}

interface ImagePreviewState {
    srcImageWidth?: number;
    srcImageHeight?: number;
}

export class ImagePreview extends React.Component<ImagePreviewProps, ImagePreviewState> {
    constructor(props: ImagePreviewProps) {
        super(props);
        this.state = {};
    }

    private calculateAspectRatioFit(srcWidth: number, srcHeight: number) {
        const { maxWidth, maxHeight } = this.props;
        const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

        return { maxWidth: `${srcWidth * ratio}px`, maxHeight: `${srcHeight * ratio}px` };
    }

    private getSrcDimensions(imageUrl: string) {
        let image = new Image();
        image.src = imageUrl;

        image.onload = () => {
            this.setState({
                srcImageWidth: image.width,
                srcImageHeight: image.height
            });
        };
    }

    public componentDidMount() {
        this.getSrcDimensions(this.props.imageUrl);
    }

    public componentWillReceiveProps(nextProps: ImagePreviewProps) {
        if (nextProps.imageUrl !== this.props.imageUrl) {
            this.getSrcDimensions(nextProps.imageUrl);
        }
    }

    render() {
        const { imageUrl } = this.props;
        const { srcImageWidth, srcImageHeight } = this.state;

        if (!srcImageWidth && !srcImageHeight) {
            return null;
        }

        const dimensions = this.calculateAspectRatioFit(srcImageWidth!, srcImageHeight!);
        return <img style={dimensions} src={imageUrl} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/imageUpload/ImagePreview.tsx